import { editBureauSaga } from './editBureau'
import { getAllBureauxSaga } from './getAllBureaux'
import { deleteBureauSaga } from './deleteBureau'
import { addBureauSaga } from './addBureau'

const userSagas = [
    editBureauSaga,
    deleteBureauSaga,
    addBureauSaga,
    getAllBureauxSaga,
]

export default userSagas
